<!-- ROAMING PARTNERS-->
<div id="getRoamingPartners" class="table-header margin-top-30">
  <span>Roaming Partners</span>
  <div class="table-filter">
    <form class="form-inline">
      <select id="table-roaming-search"
              [(ngModel)]="optionRoamingPartnerSearch"
              name="optionRoamingPartnerSearch"
              class="table-filter-search form-control"
              (change)='onOptionRoamingPartnerSearchChanged($event)'>
        <option selected="selected">Search Type</option>
        <option>NetID</option>
        <option>Name</option>
      </select>
      <input type="text"
        class="form-control"
        id="input-roaming-search"
        name="inputKeywordRoamingPartnerSearch"
        aria-describedby="search"
        placeholder="Search"
        [(ngModel)]="inputKeywordRoamingPartnerSearch"
        (keyup)="onKeywordSearch($event)">
      <i class="fa fa-search text-tooltip"
        aria-hidden="true" title-popup="Search" (click)="refreshRoamingPartners()">
      </i>
    </form>
  </div>
  <div class="position-relative table-icon action">
    <i class="fa fa-list transition text-tooltip" aria-hidden="true" title-popup="List"></i>
    <div class="tooltip-actions width-120">
      <div class="arrow-up"></div>
      <ul>
        <li>
          <label col-id="0"
            table-name="roaming-partners-list"
            class="checked">NetID
          </label>
        </li>
        <li>
          <label col-id="1"
            table-name="roaming-partners-list"
            class="checked">Name
          </label>
        </li>
        <li>
          <label col-id="2"
            table-name="roaming-partners-list"
            class="checked">Policy
          </label>
        </li>
        <li>
          <label col-id="3"
            table-name="roaming-partners-list"
            class="checked">sPR
          </label>
        </li>
        <li>
          <label col-id="4"
            table-name="roaming-partners-list"
            class="checked">fPR
          </label>
        </li>
        <li>
          <label col-id="5"
            table-name="roaming-partners-list"
            class="checked">sPRA
          </label>
        </li>
        <li>
          <label col-id="6"
            table-name="roaming-partners-list"
            class="checked">fPRA
          </label>
        </li>
        <li>
          <label col-id="7"
            table-name="roaming-partners-list"
            class="checked">sUL
          </label>
        </li>
        <li>
          <label col-id="8"
            table-name="roaming-partners-list"
            class="checked">fUL
          </label>
        </li>
        <li>
          <label col-id="9"
            table-name="roaming-partners-list"
            class="checked">ULbal
          </label>
        </li>
        <li>
          <label col-id="10"
            table-name="roaming-partners-list"
            class="checked">sULtol
          </label>
        </li>
        <li>
          <label col-id="11"
            table-name="roaming-partners-list"
            class="checked">fULtol
          </label>
        </li>
        <li>
          <label col-id="12"
            table-name="roaming-partners-list"
            class="checked">sDL
          </label>
        </li>
        <li>
          <label col-id="13"
            table-name="roaming-partners-list"
            class="checked">fDL
          </label>
        </li>
        <li>
          <label col-id="14"
            table-name="roaming-partners-list"
            class="checked">DLbal
          </label>
        </li>
        <li>
          <label col-id="15"
            table-name="roaming-partners-list"
            class="checked">sDLtol
          </label>
        </li>
        <li>
          <label col-id="16"
            table-name="roaming-partners-list"
            class="checked">fDLtol
          </label>
        </li>
        <li>
          <label col-id="17"
            table-name="roaming-partners-list"
            class="checked">locIn
          </label>
        </li>
        <li>
          <label col-id="18"
            table-name="roaming-partners-list"
            class="checked">locOut
          </label>
        </li>
        <li>
          <label col-id="19"
                 table-name="roaming-partners-list"
                 class="checked">heliumIn
          </label>
        </li>
        <li>
          <label col-id="20"
                 table-name="roaming-partners-list"
                 class="checked">heliumOut
          </label>
        </li>
        <!--
        <li>
          <label col-id="19"
            table-name="roaming-partners-list"
            class="checked">Reject UL/DL
          </label>
        </li>
        <li>
          <label col-id="20"
            table-name="roaming-partners-list"
            class="checked">Reject Loc
          </label>
        </li>
        -->
      </ul>
    </div>
  </div>
  <div class="table-icon refresh" (click)="refreshRoamingPartners()">
    <i class="text-tooltip" [ngClass]="(roamingPartnersRefreshing)?'fa fa-spinner fa-spin':'fa fa-refresh'" aria-hidden="true" title-popup="Refresh"></i>
  </div>
  <div *ngIf="isAdmin && canAddRoamingPartners && !renderNsGroup" class="table-icon plus">
    <i class="fa fa-plus transition text-tooltip"
      (click)=createRoamingPartnersPage(name,netIds,virtId,createRP)
      aria-hidden="true"
      title-popup="Add"></i>
  </div>
</div>
<div class="table-panel">
  <table class="table-roaming-partners table table-striped table-responsive" id="roaming-partners-list">
  <thead>
    <tr>
      <th>NetID</th>
      <th>Name</th>
      <th class="peering-type-th ">Peering Type</th>
      <th class="text-tooltip"
        title-popup="Allow Passive Roaming (NS on this row as sNS)">sPR</th>
      <th class="text-tooltip" title-popup="Allow Passive Roaming (NS on this row as fNS)">fPR</th>
      <th class="text-tooltip"
        title-popup="Allow Passive Roaming Activation (NS on this row as sNS)">sPRA</th>
      <th class="text-tooltip"
        title-popup="Allow Passive Roaming Activation (NS on this row as fNS)">fPRA</th>
      <th class="text-tooltip"
        title-popup="Number of UL frames (NS on this row as sNS)">sUL</th>
      <th class="text-tooltip"
        title-popup="Number of UL frames (NS on this row as fNS)">fUL</th>
      <th class="text-tooltip"
        title-popup="UL balance of NS on this row, fUL-sUL">ULbal</th>
      <th class="text-tooltip"
        title-popup="UL tolerance allowed for NS on this row">sULtol</th>
      <th class="text-tooltip"
        title-popup="UL tolerance allowed for NS on this page">fULtol</th>
      <th class="text-tooltip"
        title-popup="Number of downlink frames forwarded while selected NS is acting as sNS">sDL</th>
      <th class="text-tooltip"
        title-popup="Number of downlink frames forwarded while selected NS is acting as fNS">fDL</th>
      <th class="text-tooltip"
        title-popup="DL balance of NS on this row, fDL-sDL">DLbal</th>
      <th class="text-tooltip"
        title-popup="DL tolerance allowed for NS on this row">sDLtol</th>
      <th class="text-tooltip"
        title-popup="DL tolerance allowed for NS on this page">fDLtol</th>
      <th class="text-tooltip"
        title-popup="Incoming Loc Frames">LocIn</th>
      <th class="text-tooltip"
        title-popup="Outgoing Loc Frames">LocOut</th>
      <th class="text-tooltip"
          title-popup="Incoming Loc Frames">HeliumIn</th>
      <th class="text-tooltip"
          title-popup="Outgoing Loc Frames">HeliumOut</th>
      <!--
      <th class="text-tooltip"
        title-popup="Rejected UL/DL Messages">Reject UL/DL</th>
      <th class="text-tooltip"
        title-popup="Rejected Loc Messages">Reject Loc</th>
      -->
      <th *ngIf="isAdmin && !renderNsGroup"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of listRoamingPartners | paginate: configPagerRoamingPartners">
      <td *ngIf="isAdmin && !item.isNSGroup" class="roamingPartners-netId-td"><a [routerLink]="['/network',item.virtId]">{{item.netIds | cidr}}</a></td>
      <td *ngIf="!isAdmin && !item.isNSGroup" class="roamingPartners-netId-td">{{item.netIds | cidr}}</td>
      <td *ngIf="isAdmin && item.isNSGroup" class="roamingPartners-netId-td"><a [routerLink]="['/network-group',item.virtId]">{{item.netIds | cidr}}</a></td>
      <td *ngIf="!isAdmin && item.isNSGroup" class="roamingPartners-netId-td">{{item.netIds | cidr}}</td>
      <td *ngIf="isAdmin && !item.isNSGroup"><a [routerLink]="['/network',item.virtId]">{{item.name}}</a></td>
      <td *ngIf="!isAdmin && !item.isNSGroup">{{item.name}}</td>
      <td *ngIf="isAdmin && item.isNSGroup"><a [routerLink]="['/network-group',item.virtId]">{{item.name}}</a></td>
      <td *ngIf="!isAdmin && item.isNSGroup">{{item.name}}</td>
      <td>{{item.policyType}}</td>
      <td>
        <i class="fa fa-check {{item.sPR}}" aria-hidden="true"></i>
      </td>
      <td>
        <i class="fa fa-check {{item.fPR}}" aria-hidden="true"></i>
      </td>
      <td>
        <i class="fa fa-check {{item.sPRA}}" aria-hidden="true"></i>
      </td>
      <td>
        <i class="fa fa-check {{item.fPRA}}" aria-hidden="true"></i>
      </td>
      <td *ngIf="item.sUL==null">0 {{item.hasError ? '(!)' : ''}}</td>
      <td *ngIf="item.sUL!=null">{{item.sUL}} {{item.hasError ? '(!)' : ''}}</td>
      <td *ngIf="item.fUL==null">0 {{item.hasError ? '(!)' : ''}}</td>
      <td *ngIf="item.fUL!=null">{{item.fUL}} {{item.hasError ? '(!)' : ''}}</td>
      <td>{{item.balUL}}</td>
      <td>{{item.snsULTh}}</td>
      <td>{{item.fnsULTh}}</td>
      <td *ngIf="item.sDL==null">0 {{item.hasError ? '(!)' : ''}}</td>
      <td *ngIf="item.sDL!=null">{{item.sDL}} {{item.hasError ? '(!)' : ''}}</td>
      <td *ngIf="item.fDL==null">0</td>
      <td *ngIf="item.fDL!=null">{{item.fDL}} {{item.hasError ? '(!)' : ''}}</td>
      <td>{{item.balDL}}</td>
      <td>{{item.snsDLTh}}</td>
      <td>{{item.fnsDLTh}}</td>
      <td *ngIf="item.locIn==null">0 {{item.hasError ? '(!)' : ''}}</td>
      <td *ngIf="item.locIn!=null">{{item.locIn}} {{item.hasError ? '(!)' : ''}}</td>
      <td *ngIf="item.locOut==null">0 {{item.hasError ? '(!)' : ''}}</td>
      <td *ngIf="item.locOut!=null">{{item.locOut}} {{item.hasError ? '(!)' : ''}}</td>
      <td *ngIf="item.heliumIn==null">0 {{item.hasError ? '(!)' : ''}}</td>
      <td *ngIf="item.heliumIn!=null">{{item.heliumIn}} {{item.hasError ? '(!)' : ''}}</td>
      <td *ngIf="item.heliumOut==null">0 {{item.hasError ? '(!)' : ''}}</td>
      <td *ngIf="item.heliumOut!=null">{{item.heliumOut}} {{item.hasError ? '(!)' : ''}}</td>
      <!--
      <td *ngIf="item.fRjct==null">0</td>
      <td *ngIf="item.fRjct!=null">{{item.fRjct}}</td>
      <td *ngIf="item.locRjct==null">0</td>
      <td *ngIf="item.locRjct!=null">{{item.locRjct}}</td>
      -->
      <td *ngIf="isAdmin && !renderNsGroup">
        <ng-template #actionsPopup>
          <p class="popup-text"
            (click)="editRoamingPartners(virtId, item.virtId, name, item.name, netIds, item.netIds)">
            Edit
          </p>
          <p class="popup-text" (click)="deleteModal.show()">Delete</p>
        </ng-template>
        <button (click)="sendRoamingParteners(i)"
                class="view-detail-btn"
                [popover]="actionsPopup"
                placement="left"
                triggers="click"
                [outsideClick]="true"
                container="body">...</button>
        <app-delete-modal #deleteModal
            text="Roaming between {{name}} and {{item.name}}  will be deleted"
            server="{{virtId}}"
            netBid="{{item.virtId}}"
            deleteType="roamingPartners">
        </app-delete-modal>
      </td>
    </tr>
  </tbody>
  </table>
  <div class="noDataRow"
    *ngIf="!listRoamingPartners || listRoamingPartners.length === 0">There is no data available
  </div>
</div>

<app-pagination-custom [config]="configPagerRoamingPartners"></app-pagination-custom>
